var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.paneType,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "paneType", $$v)
                    },
                    expression: "queryParams.paneType",
                  },
                },
                _vm._l(_vm.panes, function (item, index) {
                  return _c("el-tab-pane", {
                    key: index,
                    attrs: { label: item.label, name: item.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell style1",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.$index +
                                1 +
                                (_vm.queryParams.page - 1) *
                                  _vm.queryParams.limit
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "时间",
                  prop: "payTime",
                  width: "140",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  "min-width": "250",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单号",
                  prop: "orderNumber",
                  width: "220",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "规格", prop: "specification" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "数量",
                  prop: "skuCount",
                  align: "right",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供货价",
                  prop: "stockPrice",
                  align: "right",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "销售价",
                  prop: "retailPrice",
                  align: "right",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "纯积分",
                  prop: "point",
                  align: "right",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "积分+现金",
                  prop: "pointPrice",
                  align: "right",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "纯现金",
                  prop: "retailPrice",
                  align: "right",
                  width: "70",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌方", prop: "supplierName" },
              }),
              _c("el-table-column", { attrs: { label: "法人" } }),
              _c("el-table-column", { attrs: { label: "营业执照" } }),
              _c("el-table-column", { attrs: { label: "开户银行" } }),
              _c("el-table-column", { attrs: { label: "地址" } }),
              _c("el-table-column", { attrs: { label: "联系电话" } }),
              _c("el-table-column", { attrs: { label: "资质证件" } }),
              _c("el-table-column", { attrs: { label: "门头照" } }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }